import { loginActionIds, logoutActionIds, twoFactorActionIds } from './actions/Constants';

const initialState = {
    authenticated: false,
    token: null,
    user: {},
    // Set while a password login waits for its 2FA code:
    // { challengeToken, hint, channel: 'email'|'sms', rememberMe }
    twoFactor: null
}


export default function authentication(state = initialState, action) {
    switch(action.type) {
        case twoFactorActionIds.request:
            return Object.assign({}, state, {
                twoFactor: action.options
            });
        case twoFactorActionIds.failure:
            return Object.assign({}, state, {
                twoFactor: null
            });
        case loginActionIds.success:
            return Object.assign({}, state, {
                authenticated: true,
                token: action.options.token,
                user: action.options.user,
                twoFactor: null
            });
        case logoutActionIds.success:
            return Object.assign({}, state, initialState);
        default:
            return state;
    }
}
